import { ExternalLink, Calendar } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PROJECTS = [
  {
    id: "whatcom-bombers",
    name: "Whatcom Bombers",
    package: "Business Package",
    url: "https://whatcombombers.com",
    image: "/assets/portfolio-bombers.png",
    aspect: "aspect-[2000/1077]",
    category: "Sports Franchise · USBL",
    published: "September 3, 2026",
    description:
      "A high-energy digital home for an official team of the USBL (United States Basketball League) — rosters, schedules, ticketing, sponsorships, and fan engagement, engineered to perform on game day.",
  },
  {
    id: "celebrity-barbershop",
    name: "Celebrity Barbershop & Salon",
    package: "Starter Package",
    url: "https://celebritybarbershopandsalon.com",
    image: "/assets/portfolio-celebrity.png",
    aspect: "aspect-[2000/1081]",
    category: "Luxury Local Business · Booking",
    published: "June 3, 2026",
    description:
      "A premium booking experience for Bellingham's premier barbershop — five-star brand presence, seamless appointment flow, and a look as sharp as the cuts.",
  },
];

export function Portfolio() {
  return (
    <section id="portfolio" data-testid="portfolio-section" className="px-4 sm:px-6 lg:px-12 py-16 md:py-24 lg:py-32 bg-black">
      <div className="max-w-7xl mx-auto lg:px-20">
        <Reveal className="mb-14 md:mb-20 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-amber-400/90 font-medium mb-4">Projects</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl mx-auto">
            Recent Clients
          </h2>
        </Reveal>

        <div className="flex flex-col gap-16 md:gap-24">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.id} delay={0.05}>
              <article
                data-testid={`portfolio-card-${p.id}`}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center px-3 sm:px-0 ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
              >
                <a href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`portfolio-image-link-${p.id}`}
                  className="group relative block notched overflow-hidden gold-glow bg-[#12141C]">
                  <img src={p.image} alt={`${p.name} website`}
                    className={`w-full ${p.aspect} object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]`} />
                  <span data-testid={`portfolio-package-${p.id}`}
                    className="absolute bottom-3 right-3 hidden lg:inline-flex notched-sm border border-amber-400/50 bg-black/70 backdrop-blur-sm px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-amber-300">
                    {p.package}
                  </span>
                </a>
                <div className="text-center lg:text-left">
                  <h3 className="font-heading text-xl sm:text-2xl lg:text-3xl font-semibold tracking-tight">{p.name}</h3>
                  <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed max-w-lg">{p.description}</p>
                  <p data-testid={`portfolio-published-${p.id}`} className="mt-5 flex items-center justify-center lg:justify-start gap-2 text-xs uppercase tracking-[0.2em] text-slate-500">
                    <Calendar className="h-3.5 w-3.5 text-amber-400/70" />
                    Published {p.published}
                  </p>
                  <span data-testid={`portfolio-package-mobile-${p.id}`}
                    className="mt-3 flex w-fit mx-auto lg:hidden notched-sm border border-amber-400/50 bg-black/70 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-amber-300">
                    {p.package}
                  </span>
                  <a href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`portfolio-live-link-${p.id}`}
                    className="group mt-7 inline-flex items-center gap-2 text-sm font-semibold text-amber-300 hover:text-amber-200 transition-colors">
                    Visit Live Site
                    <ExternalLink className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
